import React from "react";
import styles from "./login.module.scss";
import { Path } from "enums";
import { Footer } from "components/commons";
import classNames from "classnames";

import { Route, Switch } from "react-router-dom";
import LoginForm from "./login.form";
const LoginModule = (props) => {
  return (
    <div className={styles.container}>
      <div className={classNames(styles.header)}>
        {/* <Image src={Logo} className={styles.logoImage} /> */}
      </div>

      <div className={styles.content}>
        <div className={styles.contentContainer}>
          <div className={styles.image}>
            {/* <Image src={Logo} className={styles.contentImage} /> */}
          </div>

          <Switch>
            <Route
              exact
              path={Path.Auth}
              render={() => <LoginForm {...props} />}
            />
          </Switch>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginModule;
